__turbopack_context__.v({
  "articleHead": "DestinationInspirationArticle-module__vnB2wq__articleHead",
  "container": "DestinationInspirationArticle-module__vnB2wq__container",
});
